import isEqual from "lodash/isEqual";

const initialState = {};

const cameraClusters = (state = initialState, action) => {
	const { payload, type } = action;
	switch (type) {
		case "INITIAL_CAMERA_CLUSTERS_BATCH_RECEIVED": {
			const { clusters } = payload;
			// Transform the array into an object keyed by `id`
			const clustersById = Array.isArray(clusters)
				? clusters.reduce((acc, cluster) => {
						cluster.tempRows = cluster.rows;
						cluster.tempColumns = cluster.columns;
						acc[cluster.id] = cluster;
						return acc;
					}, {})
				: {};
			return {
				...state,
				...clustersById
			};
		}
		case "ADD_CAMERA_CLUSTER": {
			const { cluster } = payload;
			cluster.tempRows = cluster.rows;
			cluster.tempColumns = cluster.columns;
			return {
				...state,
				[cluster.id]: cluster
			};
		}
		case "UPDATE_CLUSTER_CAMERASLOTS": {
			const { cameras, clusterId } = payload;
			const cluster = state[clusterId];
			if (!cluster) return state;

			if (isEqual(cluster.cameras, cameras)) return state;

			return {
				...state,
				[clusterId]: {
					...cluster,
					cameras
				}
			};
		}

		case "UPDATE_CLUSTER_CAMERASLOTS": {
			const { cameras, clusterId } = payload;

			if (!state[clusterId]) {
				return state;
			}
			return {
				...state,
				[clusterId]: {
					...state[clusterId],
					cameras
				}
			};
		}
		case "REMOVE_CAMERA_CLUSTERS": {
			const { clusterIds } = payload;
			// Filter out the clusters whose id is in clusterIds
			const newState = { ...state };
			clusterIds.forEach(id => {
				delete newState[id];
			});
			return newState;
		}
		case "UPDATE_CAMERA_CLUSTER_ROWS_AND_COLUMNS": {
			const { rows, columns, clusterId } = payload;

			if (!state[clusterId]) return state;
			return {
				...state,
				[clusterId]: {
					...state[clusterId],
					tempRows: rows,
					tempColumns: columns
				}
			};
		}
		case "RESET_CAMERA_CLUSTER_ROWS_AND_COLUMNS_TO_DEFAULT": {
			const { clusterId } = payload;
			const cluster = state[clusterId];
			if (!cluster) return state;

			return {
				...state,
				[clusterId]: {
					...cluster,
					tempRows: cluster.rows,
					tempColumns: cluster.columns
				}
			};
		}

		default:
			return state;
	}
};

export default cameraClusters;
